import { Compass } from "@phosphor-icons/react";

import Skeleton from "common/components/ui/Skeleton";
import { Tag } from "common/components/ui/Tag";

import { NAVIGATOR_FILTER_CATEGORIES } from "../../../constants";

import type {
  NavigatorFiltersTargeting,
  NavigatorUrlTargeting,
} from "../../../types";

export default function NavigatorTargetingLabels({
  targeting,
  isLoading,
}: {
  targeting: NavigatorFiltersTargeting | NavigatorUrlTargeting;
  isLoading: boolean;
}) {
  if (isLoading) {
    return (
      <div className="flex flex-wrap gap-1.5">
        <Skeleton className="h-7 w-32" />
        <Skeleton className="h-7 w-32" />
      </div>
    );
  }
  if ("url" in targeting) {
    return (
      <Tag
        size="md"
        variant="primary-black"
        leftIcon={<Compass weight="fill" />}
      >
        Sales Navigator Search URL
      </Tag>
    );
  }
  return (
    <div className="flex flex-wrap gap-1.5">
      {targeting.keywords && (
        <Tag size="md" variant="primary-black">
          {targeting.keywords}
        </Tag>
      )}
      {targeting.filters.map(({ values, type }) =>
        values.map(({ id, text, selectionType }) => {
          const { icon } = NAVIGATOR_FILTER_CATEGORIES.find(({ filters }) =>
            filters.find((filter) => {
              if ("subFilters" in filter) {
                return filter.subFilters.find(
                  (subFilter) => subFilter.type === type,
                );
              }
              return filter.type === type;
            }),
          );
          return (
            <Tag
              key={id}
              size="md"
              leftIcon={icon}
              variant={
                selectionType === "INCLUDED" ? "primary-black" : "danger"
              }
            >
              {text}
            </Tag>
          );
        }),
      )}
    </div>
  );
}
